<script setup lang="ts">
import type { Agent } from '@@/shared/agent/types';

defineProps<{
  agent: Agent
}>();
</script>

<template>
  <div class="flex gap-m items-center">
    <IadTitle
      :text="$t('agent.about.follow_me')"
      variant="x-small"
      tag="p"
      class="hidden lg:block"
    />
    <div class="flex gap-s">
      <IadBtn
        v-for="socialNetwork of agent.socialNetworks"
        :key="socialNetwork.name"
        icon
        variant="outlined"
        :href="socialNetwork.url"
        target="_blank"
      >
        <Icon :name="socialNetwork.icon" />
      </IadBtn>
    </div>
  </div>
</template>
